// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
}

.patientListBtn {
  background-color: #3a65fe;
  padding: 5px 10px;
  color: #fff;
  font-weight: 500;
  border-radius: 20px;
}
.patientListBtn:hover {
  background-color: #123fe4;
  cursor: pointer;
}

.patientListBtn:disabled {
  background-color: grey;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/views/admin/protocol/protocol.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 5px;\n}\n\n.patientListBtn {\n  background-color: #3a65fe;\n  padding: 5px 10px;\n  color: #fff;\n  font-weight: 500;\n  border-radius: 20px;\n}\n.patientListBtn:hover {\n  background-color: #123fe4;\n  cursor: pointer;\n}\n\n.patientListBtn:disabled {\n  background-color: grey;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
